// TASKTITLE: the title a task row is SHOWN with.
//
// The server builds it from the task type and the viewer (services/task_title.py), in English and
// French, so "Upload your ..." is only ever shown to the employee the task is about and anyone
// else reads "Upload the ... for <name>". This picks the language the screen is in. A row without
// a French title (a task type with no rule, or an older payload) shows its title unchanged.
import i18n from 'i18next';

export function shownTaskTitle(task, field = 'title') {
  if (!task) return '';
  const lang = (i18n && i18n.language) || 'en';
  const fr = task[`${field}_fr`];
  return lang.startsWith('fr') && fr ? fr : (task[field] || '');
}

export default shownTaskTitle;
